module.exports = __webpack_public_path__ + "img/justify.02aae7fd.svg";